/**
 * @generated SignedSource<<7da7b17de9b59f79ab1a5b72551e05f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AutoRecordReasonStream$variables = {
  id: string;
};
export type AutoRecordReasonStream$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"StartAndAutoRecordingControls_refetchableAutoRecordReason">;
  } | null;
};
export type AutoRecordReasonStream = {
  response: AutoRecordReasonStream$data;
  variables: AutoRecordReasonStream$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isViewer",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AutoRecordReasonStream",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StartAndAutoRecordingControls_refetchableAutoRecordReason"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AutoRecordReasonStream",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "autoRecordSetting",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "NoteStreamStreamBasedAutoRecordSource",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "users",
                        "plural": true,
                        "selections": (v4/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AutoRecordRule",
                        "kind": "LinkedField",
                        "name": "rules",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ruleLevel",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AutoRecordRuleUser",
                            "kind": "LinkedField",
                            "name": "autoRecordRuleUsers",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": (v4/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cannotBeRecordedReason",
                        "storageKey": null
                      }
                    ],
                    "type": "NoteStreamUserSettingsBasedAutoRecordEnableSource",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "NoteStream",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6e9e55403b741884a4cd511f6839d98d",
    "id": null,
    "metadata": {},
    "name": "AutoRecordReasonStream",
    "operationKind": "query",
    "text": "query AutoRecordReasonStream(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...StartAndAutoRecordingControls_refetchableAutoRecordReason\n    id\n  }\n}\n\nfragment StartAndAutoRecordingControls_refetchableAutoRecordReason on NoteStream {\n  ...StreamAutoRecordAutomationConfig_useAutoRecordReason_stream\n  id\n}\n\nfragment StreamAutoRecordAutomationConfig_useAutoRecordReason_stream on NoteStream {\n  autoRecordSetting {\n    __typename\n    ... on NoteStreamStreamBasedAutoRecordSource {\n      value\n      creator {\n        id\n        firstName\n        fullName\n        isViewer\n      }\n    }\n    ... on NoteStreamUserSettingsBasedAutoRecordEnableSource {\n      users {\n        id\n        firstName\n        fullName\n        isViewer\n      }\n      rules {\n        ruleLevel\n        autoRecordRuleUsers {\n          user {\n            id\n            firstName\n            fullName\n            isViewer\n          }\n        }\n        id\n      }\n      cannotBeRecordedReason\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b74077c53a25d52dbd2d50a6ad9f13f";

export default node;
